import {Observable} from 'rxjs';
import {ApiV0Administration} from '../api.v0.administration';
import {LoginRes, UserDetailsRes} from '../../../../contracts/v0/cp';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';
import {RestApiService} from '../../../rest-api.service';
import {
    AdminUserEmploymentSaveReq,
    AdminUserOnboardReq,
    AdminUserOnboardRes,
    GenerateTemporaryPasswordReq,
    RmEmploymentDetailRes,
    SetPasswordReq
} from '../../../../contracts/v0/administration/account.contracts';

export class ApiV0AdminAccounts {
    segment = '/accounts';

    constructor(
        v0: ApiV0Administration,
        private rest: RestApiService
    ) {
        this.segment = v0.segment + this.segment;
    }

    setPassword(id: number, dto: SetPasswordReq): Observable<LoginRes> {
        return this.rest.patch<SetPasswordReq, LoginRes>(`${this.segment}/${id}/setPassword`, LoginRes, dto);
    }

    generateTemporaryPassword(id: number, dto: GenerateTemporaryPasswordReq = new GenerateTemporaryPasswordReq()): Observable<UserDetailsRes> {
        return this.rest.patch<GenerateTemporaryPasswordReq, UserDetailsRes>(
            `${this.segment}/${id}/generateTemporaryPassword`,
            UserDetailsRes,
            dto
        );
    }

    search(searchModel: SearchModel = new SearchModel({})): Observable<BaseCollectionModel<UserDetailsRes>> {
        return this.rest.post<SearchModel, BaseCollectionModel<UserDetailsRes>>(`${this.segment}/search`, UserDetailsRes, searchModel);
    }

    onboard(dto: AdminUserOnboardReq): Observable<AdminUserOnboardRes> {
        return this.rest.post<AdminUserOnboardReq, AdminUserOnboardRes>(`${this.segment}/onboard`, AdminUserOnboardRes, dto);
    }

    employment(id: number): Observable<RmEmploymentDetailRes | null> {
        return this.rest.get<RmEmploymentDetailRes | null>(`${this.segment}/${id}/employment`, RmEmploymentDetailRes);
    }

    saveEmployment(id: number, dto: AdminUserEmploymentSaveReq): Observable<RmEmploymentDetailRes> {
        return this.rest.patch<AdminUserEmploymentSaveReq, RmEmploymentDetailRes>(
            `${this.segment}/${id}/employment`,
            RmEmploymentDetailRes,
            dto
        );
    }

    lockout(id: number): Observable<UserDetailsRes> {
        return this.rest.patch<{}, UserDetailsRes>(`${this.segment}/${id}/lockout`, UserDetailsRes);
    }

    unlock(id: number): Observable<UserDetailsRes> {
        return this.rest.patch<{}, UserDetailsRes>(`${this.segment}/${id}/unlock`, UserDetailsRes);
    }
}
